/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_ActionsInputs */



/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Overview_ActionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_actions = /** @type {((inputs?: Overview_ActionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_ActionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azioni")
	return /** @type {LocalizedString} */ ("Actions")
});